module.exports = __webpack_public_path__ + "img/Frame-1.a2f8bc67.svg";